import { isNumber, isNil } from 'lodash-es';

export const toArray = (value: any) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'string') {
    return value ? [value] : [];
  }

  return !isNil(value) && value !== '' ? [value] : [];
};

export const toStrArray = (value: any) => {
  if (Array.isArray(value) && value.length > 0) {
    return [`${value?.[0]}`];
  }
  if (typeof value === 'string') {
    return value ? [value] : [];
  }

  return !isNil(value) && value !== '' ? [`${value}`] : [];
};

export const toNumArray = (value: string | string[]) => {
  if (Array.isArray(value)) {
    return value;
  }

  return isNumber(value) ? [value] : [];
};


